<app-capture-history-item-title>
  Capture Updated by Chore
</app-capture-history-item-title>

<app-capture-history-item-body>
  {{ references }}
  <br/>
  Note: {{ note }}
</app-capture-history-item-body>
